<mat-accordion>

  <mat-expansion-panel>
    <mat-expansion-panel-header>

      <mat-panel-title>

        <span class="title-style">{{ title }}</span>
        <span class="is-mandatory" style="color: #ff8282"></span>

      </mat-panel-title>

      <mat-panel-description>
        <!-- COLOCAR ÍCONE DE ADICIONAR/EDITAR AQUI-->
        X
      </mat-panel-description>

    </mat-expansion-panel-header>

  </mat-expansion-panel>
</mat-accordion>
